import * as React from "react";

function SvgCrowdPower(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 130 130"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <circle fill="#0064FF" cx={66.942} cy={65} r={50} />
      <path
        fill="none"
        stroke="#FFF"
        strokeWidth={7}
        strokeMiterlimit={10}
        d="M73.323 54.062l-6.381-11.053-20 34.641h40L80.56 66.598"
      />
    </svg>
  );
}

export default React.forwardRef(SvgCrowdPower);
